<template>
    <div class="form-info">
        <el-form :model="checkItem" ref="staffQualiTypeInfo">
            <div class="form-row">
                <div class="form-label">
                    <label>参考标准</label>
                </div>
                <div class="form-value width-2x">
                    <span>{{checkItem.standard}}</span>
                </div>
            </div>
            <div class="form-row">
                <div class="form-label">
                    <label>项目内容</label>
                </div>
                <div class="form-value width-2x">
                    <span>{{checkItem.content}}</span>
                </div>
            </div>
            <div class="form-row">
                <div class="form-label">
                    <label>基本要求</label>
                </div>
                <div class="form-value width-2x">
                    <span>{{checkItem.demand}}</span>
                </div>
            </div>
            <div class="form-row">
                <div class="form-label">
                    <label>适用分类</label>
                </div>
                <div class="form-value width-2x">
                    <span>{{checkItem.appliedCatNames}}</span>
                </div>
            </div>
        </el-form>
    </div>
</template>

<script>
    import { Utils } from '../../app.base'
    import { Vue, MsgBox, Routes } from '../../app.vues'

    import rentServcApi from '../../api/rentServc'

    export default {
        name: 'swb-check-item-detail',
        desc: '凭单检查项详情',
        props: ['id'],
        data: function () {
            return {
                checkItem: {}
            }
        },
        created: function () {
            this.getDevcMaintCheckItemById();
        },
        methods: {
            getDevcMaintCheckItemById(){
                let self = this;
                let postData = {};
                postData.id = self.id;
                rentServcApi.getDevcMaintCheckItemById(postData, function (result) {
                    if(result.type == 'info') {
                        self.checkItem = result.data;
                    } else {
                        MsgBox.warning(result.message);
                    }
                });
            },
        }
    }
</script>



// WEBPACK FOOTER //
// src/compo/rentServc/DevcMaintCheckItemDetail.vue